import { render, staticRenderFns } from "./LocationStatusSwitch.vue?vue&type=template&id=252924c6"
import script from "./LocationStatusSwitch.vue?vue&type=script&lang=ts"
export * from "./LocationStatusSwitch.vue?vue&type=script&lang=ts"
import style0 from "./LocationStatusSwitch.vue?vue&type=style&index=0&id=252924c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports